export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6593.a403fe55.jpg";